import { useEffect, useState } from '@bpmn-io/properties-panel/preact/hooks';
import type { FetchState } from '../../../types/properties-panel';
import type { SpSiteOrList } from '../../../types/sharepoint';
import { useMountRef } from './useMountRef';
import { useService } from './useService';

type FS = FetchState<SpSiteOrList[]>;

export const useFetchSpSubSites = ({
    enabled = true,
    siteUrl,
}: {
    enabled?: boolean;
    siteUrl?: string;
}): FS => {
    const mountRef = useMountRef();
    const [state, setState] = useState<Record<string, FS>>({});
    const eventBus = useService('eventBus');

    // event listener
    useEffect(() => {
        const handler = (_event: any, siteUrl: string, newSiteListsState: FS) => {
            if (!mountRef.current) return;

            setState((prevState) => ({
                ...prevState,
                [siteUrl]: newSiteListsState,
            }));
        };

        eventBus.on('spSubSitesFetched', handler);
        return () => eventBus.off('spSubSitesFetched', handler);
    }, []);

    useEffect(() => {
        if (!enabled || !siteUrl) return;

        setState((prev) => {
            eventBus.fire('fetchSpSubSites', siteUrl);

            return {
                ...prev,
                [siteUrl]: { loading: true, data: prev[siteUrl]?.data, error: undefined },
            };
        });
    }, [enabled, siteUrl]);

    return (siteUrl && state[siteUrl]) || {};
};
